import setContactFormImport from './setContactForm'
// import setContactFormFieldImport from './setContactFormField'
import setContactFormSortImport from './setContactFormSort'

export const setContactForm = setContactFormImport
// export const setContactFormField = setContactFormFieldImport
export const setContactFormSort = setContactFormSortImport



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/mutations/index.js